import { replace } from 'react-router-redux'
import { SIGN_IN_SUCCESS, SIGN_OUT_SUCCESS } from 'modules/auth'
import { UPDATE_SUBSCRIPTION } from 'modules/subscriptions'
import { CREATE_SITE_SUCCESS, DELETE_SITE_SUCCESS } from 'modules/sites/action-types'
import {
  SITES_PATH,
  SITE_PATH,
  ACCOUNT_BILLING_PATH,
  POST_SIGN_IN_PATH,
  POST_SIGN_OUT_PATH,
} from 'config'
import { PASSWORD_RESET_SUCCESS } from '../../modules/auth/action-types';
import { PASSWORD_PATH, SIGN_IN_PATH } from '../../config';


export default ({ dispatch }) => next => action => {
  const result = next(action)

  if (typeof action === 'object') {
    switch (action.type) {
      case CREATE_SITE_SUCCESS:
        dispatch(replace(SITE_PATH.replace(':site', action.payload.key)));
        break;

      case DELETE_SITE_SUCCESS:
        dispatch(replace(SITES_PATH))
        break

      case SIGN_IN_SUCCESS:
        dispatch(replace(POST_SIGN_IN_PATH))
        break

      case UPDATE_SUBSCRIPTION:
        dispatch(replace(ACCOUNT_BILLING_PATH))
        break

      case SIGN_OUT_SUCCESS:
        dispatch(replace(POST_SIGN_OUT_PATH))
        break

      case PASSWORD_RESET_SUCCESS:
        dispatch(replace(`${SIGN_IN_PATH}${action.payload.success ? `?success=${action.payload.success}` : ''}`))
        break

      default:
        break
    }
  }

  return result
}



// WEBPACK FOOTER //
// ./src/redux/middlewares/redirects.js